import * as React from 'react';

function SvgTwitterIcon(props) {
  return (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
      <circle cx={16} cy={16} r={16} fill="#000" />
      <path
        d="M23.576 11.377c-.494.21-1.018.33-1.543.42.247-.03.617-.48.771-.66.216-.269.402-.568.525-.898 0-.03.03-.06 0-.09h-.093c-.586.3-1.172.51-1.82.69-.062 0-.093 0-.124-.03-.061-.06-.092-.12-.154-.15a4.387 4.387 0 00-.895-.54 3.64 3.64 0 00-1.388-.209c-.463.03-.895.15-1.296.36-.402.209-.772.479-1.05.838-.308.36-.524.778-.617 1.198-.092.419-.092.838-.03 1.287 0 .06 0 .09-.062.06-2.5-.359-4.567-1.228-6.265-3.114-.061-.09-.123-.09-.185 0-.74 1.078-.37 2.815.556 3.653.123.12.247.24.4.33-.06 0-.678-.06-1.203-.33-.061-.06-.123-.03-.123.06 0 .12 0 .21.03.36.155 1.078.927 2.096 1.976 2.485.123.06.277.09.4.12-.246.06-.493.09-1.203.03-.092-.03-.123.03-.092.12.524 1.377 1.666 1.796 2.5 2.036.123.03.215.03.339.06l-.031.03c-.278.42-1.265.719-1.697.868-.833.27-1.728.42-2.592.33-.155-.03-.155-.03-.216 0-.031.03 0 .06.03.09.186.12.37.21.525.299.556.27 1.142.51 1.728.659 3.117.838 6.635.21 8.95-2.037 1.85-1.766 2.468-4.222 2.468-6.648 0-.09.123-.15.185-.21.463-.359.864-.778 1.203-1.227.093-.09.062-.21.062-.24.093-.06.093-.03.03 0z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.424 22.068c0-.03.278 0 0 0 0-.03.03 0 0 0z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgTwitterIcon;
